module.exports = __webpack_public_path__ + "static/media/albayen1.7c21fc4f.png";